import React from "react";
import {Switch, Route, Redirect} from 'react-router-dom';
import SingIn from './SignIn';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';

const Auth = () => (
  <Switch>
    <Route exact path='/auth/signin' component={SingIn} />
    <Route exact path='/auth/signup' component={SignUp} />
    <Route exact path='/auth/forgot' component={ForgotPassword} />
    <Route exact path='/auth/password-reset/:token' component={ResetPassword} />
    <Redirect to='/auth/signin' />
  </Switch>
);

export default Auth;
